import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid/Grid';
import Card from '@material-ui/core/Card/Card';
import CardContent from '@material-ui/core/CardContent/CardContent';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography/Typography';
import TextField from '@material-ui/core/TextField/TextField';
import Icon from '@material-ui/core/Icon/Icon';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Switch from '@material-ui/core/Switch/Switch';
import CardActions from '@material-ui/core/CardActions/CardActions';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { isMobileDevice } from '@configuratorware/configurator-frontendgui/Framework/Helpers/isMobileDevice';
import { createSelectionRangeMemo } from '@configuratorware/configurator-frontendgui/Utils/Helper/createSelectionRangeMemo';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { withResizeDetectWrapper } from '@configuratorware/configurator-frontendgui/Shared/HOCs/ResizeDetect/ResizeDetect';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';

const styles = (theme) => ({
  bobbelWrapper: {
    border: '7px solid transparent',
    width: 35,
    height: 35,
    borderRadius: '50%',

  },
  container: {
    pointerEvents: 'all', // catch the pointer events again
    zIndex: 15,
    position: 'fixed',
    bottom: 0,
    width: '100%',
    top: 0,
    left: 0,
    paddingBottom: 0,
    background: 'white',
    [theme.breakpoints.up('md')]: {
      width: '40vw',
      maxWidth:300,
      paddingBottom: 20,
      left: 16,
      background: 'transparent',
      '& > .MuiGrid-item': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  card: {
    [theme.breakpoints.up('md')]: {
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    borderTop: `7px solid ${theme.palette.primary.main}`,
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      boxShadow: 'none',
    },
  },
  colorCardActions: {
    padding: '0 16px 16px 16px',

    [theme.breakpoints.down('xs')]: {
      padding: '0 16px',
      display: 'flex',
      height: 56,
      bottom: 16,
      right: 0,
      left: 0,
      position: 'fixed',
      background: 'white',
    },
  },
  cardUnboxed: {
    height: '100%',
    borderTop: 'none',
    boxShadow: 'none',

    [theme.breakpoints.down('xs')]: {
      boxShadow: 'none',
    },
  },
  customColorGrid: {
    textAlign: 'center',
    margin: 'auto',
  },
  alignTypo: {
    marginBottom: '16px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '9px',
    },
  },
  colorPaletteTitle: {},
  arrowNone: {
    display: 'none !important',
  },
  colorPaletteColors: {
    borderRadius: '50%',
    width: 32,
    height: 32,
    minWidth: 32,
    minHeight: 32,
    cursor: 'pointer',
    border: '2px solid #707070',
  },
  colorPaletteWrapper: ({ heightColorPaletteWrapper, width, isCustomColorChecked }) => ({
    maxHeight: isWidthDown('xs', width)
      ? isCustomColorChecked
        ? heightColorPaletteWrapper - 90
        : heightColorPaletteWrapper
      : 290,
    padding: '0 16px',
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 16,
    overflowY: 'auto',
  }),
  switchBaseSpacing: {
    padding: 9,
  },
  colorPaletteSearchWrapper: {
    marginBottom: 16,
  },
  colorPaletteDisabled: {
    color: theme.palette.secondary.lighter,
  },
  colorWrapper: {
    border: '7px solid transparent',
    width: 35,
    height: 35,
    borderRadius: '50%',
    cursor: 'pointer',
    '&:hover': {
      border: '7px solid #F2F2F2',
    },
    '&:active, &:focus': {
      border: '7px solid #C9C9C9',
    },
  },
  colorWrapperSelected: {

    border: '7px solid #C9C9C9',
  },
  usedColorWrapper: {
    border: '7px solid black',
  },
  searchPaletteGrid: {
    padding: 0,
  },
  selectedColorText: {
    '& span': {
      fontSize: '12px',
      fontWeight: 'bold',
      fontStyle: 'italic',
      textDecoration: 'underline',
    },
  },
  selectColorMenu: {
    '& div': {
      '& span': {
        fontSize: 14,
        padding: '0 16px',
      },
    },
  },
  colorPaletteButton: {
    marginTop: 24,
    padding: 8,
    [theme.breakpoints.down('sm')]: {
      marginTop: '0',
    },
    [theme.breakpoints.down('xs')]: {
      height: 56,
    },
  },

  selectedColorGrid: {
    margin: '0 auto',
  },
  cardContentRoot: {},
  gridColorContent: {
    maxHeight: '100%',
  },
  RootListItem: {
    margin: '0 16px',
    padding: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
    '& span': {
      fontSize: '15px',
      maxWidth: 80,
      maxHeight: 45,
      lineHeight: 1.5,
      webkitLineClamp: 2,
      webkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '100%',
    },
  },
  selectedColorField: {
    padding: '15px 14px',
    fontSize: 15,
  },
  selectedColorLabel: {
    fontSize: 15,
  },
  disabledColorWrap: {
    cursor: 'unset',
    background: `${theme.palette.secondary.lighter} !important`,
    border: `1px solid ${theme.palette.secondary.lighter}`,
  },
  disabledColorText: {
    '& span': {
      color: `${theme.palette.secondary.lighter} !important`,
    },
  },
  selectedColorWrap: {
    boxShadow: 'none !important',
  },
  DialogCloseIcon: {
    position: 'absolute',
    right: 16,
    top: 20,

    '&:hover': {
      cursor: 'pointer',
    },
  },
  searchColorIcon: {
    left: 15,
    top: 6,
    position: 'relative',
    color: theme.palette.primary.darkText,

    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconColorWrap: {
    height: 24,
    [theme.breakpoints.down('sm')]: {
      height: 34,
    },
  },
  formControlCustomColor: {
    marginLeft: -8,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
      paddingTop: 12,
    },
  },
  underlineInputText: {
    marginBottom: 8,
    // https://github.com/mui-org/material-ui/issues/12192#issuecomment-406182809
    '&&&&:hover:before': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    },
    '&:after': {
      borderBottom: '1px solid transparent',
    },
  },
  outlinedInput: {
    fontSize: 15,
    height: 40,
    padding: '0 0 0 16px',
    cursor: 'default',
    lineHeight: '40px',
  },
  underlineSelectItem: {
    '&:after': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
  },
});

const selectionRangeMemo = createSelectionRangeMemo();
// height of header footer = 283
// height of one color element = 58
const heightColorPalette = () => Math.floor((window.innerHeight - (225 + 58)) / 58) * 58;

const ColorPaletteColorsWrapper = withStyles(styles, { name: 'ColorPaletteColorsWrapper' })(
  ({
    palette, classes, isSearchActive, renderColors,
  }) => (
    <div className={classes.colorPaletteWrapper}>{!isSearchActive && renderColors(palette)}</div>
  ),
);
class ColorPalettes extends React.Component {
    static propTypes = {
      boxed: PropTypes.bool,
      classes: PropTypes.object,
      size: PropTypes.object,
      colorPaletteIdentifier: PropTypes.string,
      width: PropTypes.string,
      colorPalettes: PropTypes.array,
      closeColorPalettes: PropTypes.func.isRequired,
      selectedColor: PropTypes.object,
      colorSelectClick: PropTypes.func,
      colorPaletteChange: PropTypes.func,
      usedColors: PropTypes.array,
      palette: PropTypes.object,
      isPortraitMode: PropTypes.bool,
    };

    constructor(props) {
      super(props);

      const { selectedColor } = this.props;
      let selectedColorData = selectedColor && selectedColor.identifier ? selectedColor.identifier : {};
      try {
        selectedColorData = JSON.parse(selectedColorData);
      } catch (e) {
        // No action required
      }
      const customColor = selectedColorData.custom ? selectedColorData.color : '';
      const isCustomColorChecked = !!selectedColorData.custom;
      this.state = {
        customColor,
        customColorError: null,
        isCustomColorChecked,
        heightColorPaletteWrapper: heightColorPalette(),
      };
      selectionRangeMemo.save();
    }

    textInputRef = React.createRef();

    componentDidUpdate(prevProps, prevState) {
      const { selectedColor } = this.props;
      if (selectedColor.identifier.custom !== prevProps.selectedColor.identifier.custom) {
        this.setState({ isCustomColorChecked: selectedColor.identifier.custom });
        if (selectedColor.identifier.custom) {
          this.setState({ customColor: selectedColor.identifier.color });
        }
      }
      const { isCustomColorChecked } = this.state;
      // set focus to custom color field when toggling
      if (isCustomColorChecked && !prevState.isCustomColorChecked) {
        this.textInputRef.current.focus();
      }
      if (this.props.size !== prevProps.size) {
        this.setState({ heightColorPaletteWrapper: heightColorPalette() });
      }
    }

    colorSelectChange = (evt, color, paletteIdentifier, isCustomColorChecked) => {
      if (isCustomColorChecked) {
        return;
      }
      if (!isMobileDevice()) {
        // only for desktop to prevent losing the focus
        evt.preventDefault();
      }
      selectionRangeMemo.restore();
      if (isFunction(this.props.colorSelectClick)) {
        this.props.colorSelectClick(color.hex_value, color.identifier, paletteIdentifier, false);
      }
      selectionRangeMemo.save();
      if (isMobileDevice()) {
        // on mobile the soft keyboard is opened by the selection restore step
        // so it has to be closed again by removing the ranges
        window.getSelection().removeAllRanges();
      }
    };

    onColorPaletteChange = (evt) => {
      this.props.colorPaletteChange(evt.target.value);
    };

    onCustomColorChange = (evt) => {
      this.setState({
        customColor: evt.target.value,
        customColorError: null,
      });
    };

    onApplyColor = () => {
      const { customColor } = this.state;
      if (!customColor) {
        this.setState({ customColorError: t('colorPalettes.emptyColorCode') });
        return;
      }
      this.props.closeColorPalettes();
      selectionRangeMemo.restore();
      this.props.colorSelectClick(customColor, customColor, null, true);
    };

    toggleCustomColor = (event) => {
      this.setState({ isCustomColorChecked: event.target.checked });
    };

    renderColors = (palette) => {
      const { classes, selectedColor } = this.props;
      const { isCustomColorChecked } = this.state;
      const selectedColorData = { ...selectedColor };
      try {
        selectedColorData.identifier = JSON.parse(selectedColorData.identifier);
      } catch (e) {
        // No action required
      }
      const classesColorWrapSelected = `${classes.colorPaletteColors} ${classes.selectedColorWrap}`;
      const classesDisabledColorWrap = `${classes.colorPaletteColors} ${classes.disabledColorWrap}`;
      return (
        palette
            && palette.colors
            && palette.colors.map((color, colorIndex) => (
              <div
                key={colorIndex}
                className={clsx((!isCustomColorChecked
                  ? selectedColorData
                      && selectedColorData.identifier
                      && selectedColorData.identifier.color === color.identifier
                    ? classes.colorWrapperSelected
                    : null
                  : null),
                classes.colorWrapper)}
                onMouseDown={(evt) => this.colorSelectChange(
                  evt,
                  color,
                  palette.identifier ? palette.identifier : color.paletteIdentifier,
                  isCustomColorChecked,
                )}
              >
                <div
                  className={clsx((!isCustomColorChecked
                    ? selectedColorData
                        && selectedColorData.identifier
                        && selectedColorData.identifier.color === color.identifier
                      ? classesColorWrapSelected
                      : classes.colorPaletteColors
                    : classesDisabledColorWrap),
                  classes.bobbelWrapper)}
                  style={{ background: `#${color.hex_value}` }}
                  aria-label={color.title}
                  key={color.identifier}
                />

              </div>
            ))
      );
    };

    render() {
      const {
        boxed,
        classes,
        colorPalettes,
        closeColorPalettes,
        selectedColor,
        width,
        palette,
        isPortraitMode,
      } = this.props;

      console.log('!!!!!', this.state, this.props);
      const {
        customColor,
        customColorError,
        isCustomColorChecked,
        isSearchActive,
        heightColorPaletteWrapper,
      } = this.state;
      const multiplePalettes = colorPalettes.length > 1;
      return (
        <Grid
          container
          className={
                    `${classes.container
                    } ${
                      width === 'sm' ? classes.mobileContainer : ''}`
                }
        >
          <Grid item xs={12} md={12}>
            <Card className={boxed ? classes.card : classes.cardUnboxed}>
              <CardContent className={classes.cardContentRoot}>
                <Grid container>
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography
                      variant="h5"
                      className={`${classes.alignTypo} ${classes.colorPaletteTitle}`}
                    >
                      <b>{t('colorPalettes.title')}</b>
                      <Icon
                        className={classes.DialogCloseIcon}
                        onClick={closeColorPalettes}
                      >
                        close
                      </Icon>
                    </Typography>
                  </Grid>
                  <Grid className={classes.gridColorContent} item xs={12} md={12} lg={12}>
                    <ColorPaletteColorsWrapper
                      palette={palette}
                      heightColorPaletteWrapper={heightColorPaletteWrapper}
                      isCustomColorChecked={isCustomColorChecked}
                      isSearchActive={isSearchActive}
                      renderColors={this.renderColors}
                      width={width}
                    />
                    <FormControlLabel
                      classes={{ root: classes.formControlCustomColor }}
                      control={(
                        <Switch
                          classes={{ switchBase: classes.switchBaseSpacing }}
                          checked={this.state.isCustomColorChecked}
                          onChange={this.toggleCustomColor}
                          value={t('colorPalettes.ownColorRequest')}
                          color="primary"
                        />
                                          )}
                      label={t('colorPalettes.ownColorRequest')}
                    />
                    {isCustomColorChecked && (
                    <>
                      <Typography variant="body2" className={classes.alignTypo}>
                        {t('colorPalettes.description')}
                      </Typography>
                      <Grid item xs={12} md={12} lg={12}>
                        <Grid
                          className={classes.customColorGrid}
                          item
                          xs={12}
                          md={12}
                          lg={12}
                        >
                          <TextField
                            inputRef={this.textInputRef}
                            value={customColor}
                            onChange={this.onCustomColorChange}
                            variant="outlined"
                            label={t('colorPalettes.colorCode')}
                            placeholder={t('colorPalettes.colorSpecify')}
                            fullWidth
                            InputProps={{
                              classes: {
                                input: classes.selectedColorField,
                              },
                            }}
                            InputLabelProps={{
                              classes: {
                                formControl: classes.selectedColorLabel,
                              },
                            }}
                            error={!!customColorError}
                            helperText={customColorError}
                          />
                        </Grid>
                      </Grid>
                    </>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className={classes.colorCardActions}>
                <Grid className={classes.customColorGrid} item xs={12} md={12} lg={12}>
                  <AnalyticsWrapper
                    targetId="text_color"
                    data={!isCustomColorChecked ? selectedColor : customColor}
                  >
                    <MainButton
                      fullWidth
                      onClick={
                                            !isCustomColorChecked ? closeColorPalettes : this.onApplyColor
                                        }
                      className={classes.colorPaletteButton}
                      size="medium"
                      variant="contained"
                    >
                      {t('colorPalettes.apply')}
                    </MainButton>
                  </AnalyticsWrapper>
                </Grid>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      );
    }
}

export default withResizeDetectWrapper(
  withWidth({ initialWidth: 'lg' })(withStyles(styles, { name: 'ColorPalettes' })(ColorPalettes)),
);
